import React from 'react';
import '../LikeLoaderShimmer/styles.css';
import CommonBlockShimmer from '../CommonBlockShimmer';
const List = () =>
{
	return (
		<>
			<div className='divider center style-scope animated_skelton-animate' />
			<CommonBlockShimmer/>
		</>
	);
};
const MediaKitLoader = () =>
{
	return (
		<div className='flexCol '>
			{/* <div className='flexRow pdngSM'>
				<div className='flexMinWidthRow'>
					<div className='counting2 loading-shimmer' />
				</div>
				<div className='flexAutoRow'>
					<div className='counting2 loading-shimmer' />
				</div>
			</div> */}
			<div className='cardT car-cont bg-white when-NOW p2p style-scope animated_skelton-animate'>
				{[ 1, 2, 3, 4, 5, 6, 7, 8 ].map((e) => <List key={e}/>)}
				<div className='divider center style-scope animated_skelton-animate' />
			</div>
		</div>
	);
};

export default MediaKitLoader;